<template>
  <div>
    <!-- 表格栏 -->
    <el-table
      ref="KTtable"
      :data="data.list"
      :highlight-current-row="highlightCurrentRow"
      @select="selectionChange"
      @select-all="selectionChange"
      @cell-click="cellClick"
      :cell-style="cellStyle"
      @current-change="handleCurrentChange"
      v-loading="loading"
      element-loading-text="拼命加载中..."
      :border="border"
      :stripe="stripe"
      :show-overflow-tooltip="showOverflowTooltip"
      :max-height="maxHeight"
      :size="size"
      :align="align"
      style="width: 100%; font-size: 14px; height: 100%"
      :header-cell-style="tableHeaderColor"
      :row-style="tableRowStyle"
      :height="height"
    >
      <!--
        <el-table-column type="selection" width="40" v-if="showBatchDelete & showOperation"></el-table-column>
      -->
      <el-table-column
        type="index"
        label="序号"
        width="50"
        v-if="showIndex"
        align="center"
      ></el-table-column>
      <el-table-column
        type="selection"
        width="55"
        v-if="showSelect"
        align="center"
      ></el-table-column>
      <el-table-column
        v-for="(column, index) in columns"
        header-align="center"
        align="center"
        :show-overflow-tooltip="true"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
        :min-width="column.minWidth"
        :fixed="column.fixed"
        :key="`${column.prop}_${index}`"
        :type="column.type"
        :formatter="column.formatter"
      >
        <!-- :sortable="column.sortable == null ? true : column.sortable" -->
        <template slot-scope="scope">
          <el-switch
            v-if="column.slot === 'switch'"
            v-model="scope.row[column.prop]"
            :active-value="1"
            :inactive-value="0"
            disabled
          ></el-switch>
          <el-switch
            v-if="column.slot === 'switch1'"
            v-model="scope.row[column.prop]"
            :active-value="1"
            :inactive-value="0"
            @change="handleSwitch(scope.$index, scope.row)"
          ></el-switch>
          <div
            v-if="column.slot === 'play'"
            style="font-size: 22px; color: blue; cursor: pointer"
            @click="handlePlay(scope.$index, scope.row)"
          >
            <i class="el-icon-video-play play-icon"></i>
          </div>
          <div v-if="!column.slot">
            {{
              column.formatter
                ? column.formatter(scope.row[column.prop])
                : scope.row[column.prop]
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        :width="statusWidth"
        header-align="center"
        v-if="showStatus"
        align="center"
      >
        <template slot-scope="scope">
          <kt-button
            icon
            label="待确认"
            v-if="scope.row.stat == 7"
            :size="size"
            type="primary"
            @click="handleNotSure(scope.$index, scope.row)"
          />
          <kt-button
            icon
            label="下单"
            v-else-if="scope.row.stat == 1"
            :size="size"
            type="text"
          />
          <kt-button
            icon
            label="待接单"
            v-else-if="scope.row.stat == 2"
            :size="size"
            type="text"
          />
          <kt-button
            icon
            label="已接单"
            v-else-if="scope.row.stat == 3"
            :size="size"
            type="text"
          />
          <kt-button
            icon
            label="取消接单"
            v-else-if="scope.row.stat == 4"
            :size="size"
            type="text"
          />
          <kt-button
            icon
            label="签到"
            v-else-if="scope.row.stat == 5"
            :size="size"
            type="text"
          />
          <kt-button
            icon
            label="签到超时"
            v-else-if="scope.row.stat == 6"
            :size="size"
            type="text"
          />
          <kt-button
            icon
            label="签退超时"
            v-else-if="scope.row.stat == 8"
            :size="size"
            type="text"
          />
          <kt-button
            icon
            label="确认"
            v-else-if="scope.row.stat == 9"
            :size="size"
            type="text"
          />
          <kt-button
            icon
            label="确认超时"
            v-else-if="scope.row.stat == 10"
            :size="size"
            type="text"
          />
          <kt-button
            icon
            label="接单超时"
            v-else-if="scope.row.stat == 11"
            :size="size"
            type="text"
          />
          <kt-button
            icon
            label="取消下单"
            v-else-if="scope.row.stat == 12"
            :size="size"
            type="text"
          />
          <kt-button icon label v-else :size="size" type="text" />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        style="height: 100%"
        :width="operationWidth"
        fixed="right"
        v-if="showOperation"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <kt-button
            icon="el-icon-document"
            label="同意退款"
            v-if="showRefund"
            :size="size"
            type="success"
            @click="handleRefund(scope.$index, scope.row)"
          />
          <kt-button
            icon="el-icon-sort"
            label="上下线"
            v-if="showUpDown"
            :size="size"
            type="success"
            @click="handleUpDown(scope.$index, scope.row)"
          />
          <!-- icon="fa fa-edit" -->
          <kt-button
            label="修改"
            v-if="showEdit"
            :size="size"
            type="warning"
            @click="handleEdit(scope.$index, scope.row)"
          />
          <!-- icon="fa fa-trash" -->
          <kt-button
            label="删除"
            v-if="showDelete"
            :size="size"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
          />
          <kt-button
            label="查看"
            v-if="showLook"
            :size="size"
            type="success"
            @click="handleLook(scope.$index, scope.row)"
          />
          <kt-button
            label="取消"
            v-if="showCancel"
            :size="size"
            type="warning"
            @click="handleCancel(scope.$index, scope.row)"
          />
          <kt-button
            icon="el-icon-sort"
            label="上下线记录"
            v-if="showUpDownRecord"
            :size="size"
            type="success"
            @click="handleUpDownRecord(scope.$index, scope.row)"
          />
          <kt-button
            label="重置密码"
            v-if="showResetCode"
            :size="size"
            type="primary"
            @click="handleResetCode(scope.$index, scope.row)"
          />
          <kt-button
            icon="el-icon-check"
            label="审批"
            v-if="showExamine"
            :size="size"
            type="primary"
            @click="handleExamine(scope.$index, scope.row)"
          />
          <kt-button
            label="移除"
            v-if="showRemove"
            :size="size"
            type="danger"
            @click="handleRemove(scope.$index, scope.row)"
          />
          <kt-button
            icon="el-icon-phone-outline"
            label="处理"
            v-if="showHandle"
            :size="size"
            type="success"
            @click="handleHandle(scope.$index, scope.row)"
          />
          <kt-button
            icon="el-icon-refresh-left"
            label="回访"
            v-if="showRecall"
            :size="size"
            type="success"
            @click="handleRecall(scope.$index, scope.row)"
          />
          <kt-button
            icon="el-icon-thumb"
            label="激活"
            v-if="showActivate"
            :disabled="scope.row.status == 1"
            :size="size"
            type="success"
            @click="handleActivate(scope.$index, scope.row)"
          />
          <kt-button
            icon="fa fa-edit"
            label="提交审核"
            v-if="showMerchandis"
            :size="size"
            type="warning"
            @click="handleMerchandis(scope.$index, scope.row)"
          />
          <kt-button
            icon="el-icon-present"
            label="会员福利"
            v-if="showVipWelfare"
            :size="size"
            type="warning"
            @click="handleVipWelfare(scope.$index, scope.row)"
          />
          <kt-button
            label="播放"
            v-if="showPlay"
            :size="size"
            type="success"
            @click="handleCamearaPlay(scope.$index, scope.row)"
          />
          <!-- scope.row.status == 1 -->
          <kt-button
            label="添加展示"
            v-if="showProducts"
            :size="size"
            type="warning"
            @click="handleProducts(scope.$index, scope.row)"
          />
          <kt-button
            label="取消展示"
            v-if="showOffProducts"
            :size="size"
            type="info"
            @click="handleOffProducts(scope.$index, scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页栏 -->
    <div class="toolbar" style="padding: 10px; overflow: hidden">
      <!--
        <el-pagination
          layout="total, prev, pager, next, jumper"
          @current-change="refreshPageRequest"
          :current-page="pageRequest.pageNum"
          :page-size="pageRequest.pageSize"
          :total="data.total * 1 || 0"
          style="float:right;"
        ></el-pagination>
      -->
      <!-- yhw 2021/2/1 修改,使分页位置居中 -->
      <el-pagination
        background
        v-if="showPagination"
        layout="total, prev, pager, next, jumper"
        @current-change="refreshPageRequest"
        :current-page="pageRequest.pageNum"
        :page-size="pageRequest.pageSize"
        :total="data.total * 1 || 0"
        style="text-align: center"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import KtButton from "@/components/KtButton";
import bus from "../vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "KtTable",
  components: {
    KtButton,
  },
  props: {
    columns: Array, // 表格列配置
    data: Object, // 表格分页数据
    tableHeaderColor: {
      //表头的样式
      type: Function,
      default: function () {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      },
    },
    tableRowStyle: {
      //table tr 的样式   by guo 2019-7-16 添加
      type: Function,
      default: function () {
        return "";
      },
    },
    cellStyle: {
      //table cell单元格  by guo 2020-8-13 添加
      type: Function,
      default: function () {
        return "";
      },
    },
    showPagination: {
      //分页
      type: Boolean,
      default: true,
    },
    operationWidth: {
      //操作栏的宽度
      type: Number,
      default: 185,
    },
    showActivate: {
      //激活按钮的显示或隐藏
      type: Boolean,
      default: false,
    },
    showMerchandis: {
      //提交审核按钮的显示或隐藏
      type: Boolean,
      default: false,
    },
    showVipWelfare: {
      //会员福利按钮的显示或隐藏
      type: Boolean,
      default: false,
    },
    // 集团化萤石摄像头播放按钮
    showPlay: {
      type: Boolean,
      default: false,
    },
    // 集团化萤石摄像头添加展示按钮按钮
    showProducts: {
      type: Boolean,
      default: false,
    },
    showOffProducts: {
      type: Boolean,
      default: false,
    },

    showIndex: {
      //序号的显示或隐藏
      type: Boolean,
      default: false,
    },
    showSelect: {
      //修改多选操作的显示或隐藏
      type: Boolean,
      default: false,
    },
    showRefund: {
      //退款按钮的显示或隐藏
      type: Boolean,
      default: false,
    },
    showHandle: {
      //处理按钮的显示或隐藏
      type: Boolean,
      default: false,
    },
    showRecall: {
      //回访按钮的显示或隐藏
      type: Boolean,
      default: false,
    },
    showEdit: {
      //修改按钮的显示或隐藏
      type: Boolean,
      default: true,
    },
    showDelete: {
      //删除按钮的显示或隐藏
      type: Boolean,
      default: true,
    },
    showCancel: {
      type: Boolean,
      default: false,
    },
    showLook: {
      //查看按钮的显示或隐藏
      type: Boolean,
      default: true,
    },
    showResetCode: {
      //重置密码的显示和隐藏
      type: Boolean,
      default: false,
    },
    showExamine: {
      //审批按钮的显示和隐藏
      type: Boolean,
      default: false,
    },
    showRemove: {
      //移除按钮显示和隐藏
      type: Boolean,
      default: false,
    },
    showUpDown: {
      //上下线
      type: Boolean,
      default: false,
    },
    showUpDownRecord: {
      //上下线记录
      type: Boolean,
      default: false,
    },
    size: {
      // 尺寸样式
      type: String,
      default: "mini",
    },
    align: {
      // 文本对齐方式
      type: String,
      default: "center",
    },
    maxHeight: {
      // 表格最大高度   不能设置  高度不能自适应
      //   type: Number,
      //   default: 480
    },
    showOperation: {
      // 是否显示操作组件
      type: Boolean,
      default: true,
    },
    border: {
      // 是否显示边框
      type: Boolean,
      default: false,
    },
    stripe: {
      // 是否显示斑马线
      type: Boolean,
      default: true,
    },
    highlightCurrentRow: {
      // // 是否高亮当前行
      type: Boolean,
      default: true,
    },
    showOverflowTooltip: {
      // 是否单行显示
      type: Boolean,
      default: true,
    },
    showBatchDelete: {
      // 是否显示操作组件
      type: Boolean,
      default: true,
    },
    statusWidth: {
      //状态的宽度
      type: Number,
      default: 185,
    },
    showStatus: {
      //是否显示状态栏
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
    },
  },
  data() {
    return {
      // 分页信息
      pageRequest: {
        pageNum: 1,
        pageSize: 10,
      },
      pageNo: 2,
      loading: false, // 加载标识
      selections: [], // 列表选中列
      pageSelections: {},
    };
  },
  methods: {
    // 分页查询
    findPage() {
      this.loading = true;
      let callback = (res) => {
        this.loading = false;
      };
      console.log("findPage", this.pageRequest);
      this.$emit("findPage", {
        pageRequest: this.pageRequest,
        callback: callback,
      });
    },
    // 选择切换
    selectionChange(selections) {
      this.selections = selections;
      if (selections.length > 0) {
        this.pageSelections[this.pageRequest.pageNum] = [...selections];
      } else {
        delete this.pageSelections[this.pageRequest.pageNum];
      }
      this.$emit("selectionChange", {
        selections: selections,
        pageSelections: this.pageSelections,
      });
    },
    // 选择切换
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", { val: val });
    },
    // 换页刷新
    refreshPageRequest(pageNum) {
      console.log(pageNum, "33233");
      this.pageRequest.pageNum = pageNum;
      console.log(this.pageRequest.pageNum, "33233");
      this.$emit("refreshPageRequest", this.pageRequest.pageNum);
    },
    // 重置页码
    setPageNum(pageNum) {
      console.log(pageNum, "setPageNum");
      this.pageRequest.pageNum = pageNum;
    },

    // 编辑
    handleEdit(index, row) {
      this.$emit("handleEdit", { index: index, row: row });
    },
    // 删除
    handleDelete(index, row) {
      this.delete(row.id, row);
    },
    // 删除操作
    delete(ids, row) {
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning",
        closeOnClickModal: false,
        center: true,
      })
        .then(() => {
          let params = [];
          let datainfo = {};
          datainfo = Object.assign({}, row);
          let idArray = (ids + "").split(",");
          for (var i = 0; i < idArray.length; i++) {
            params.push({ id: idArray[i] });
          }
          this.loading = true;
          let callback = (res) => {
            if (res.code == 200) {
              this.$message({ message: "删除成功", type: "success" });
              this.findPage();
            } else {
              this.$message({
                message: "操作失败, " + res.message,
                type: "error",
              });
            }
            this.loading = false;
          };
          let back = (res) => {
            this.loading = false;
          };
          this.$emit("handleDelete", {
            params: params,
            datainfo: datainfo,
            callback: callback,
            back: back,
            row: row,
          });
        })
        .catch(() => {});
    },
    //switch开关按钮
    handleSwitch(index, row) {
      this.$emit("handleSwitch", { index: index, row: row });
    },
    //查看详情
    handleLook(index, row) {
      this.$emit("handleLook", { index: index, row: row });
    },
    handleCancel: function (index, row) {
      this.$emit("handleCancel", { index: index, row: row });
    },
    //重置密码
    handleResetCode(index, row) {
      this.$emit("handleResetCode", { index: index, row: row });
    },
    //待确认
    handleNotSure(index, row) {
      this.$emit("handleNotSure", { index: index, row: row });
    },
    //审批
    handleExamine(index, row) {
      this.$emit("handleExamine", { index: index, row: row });
    },
    //移除
    handleRemove(index, row) {
      this.$emit("handleRemove", { index: index, row: row });
    },
    //处理
    handleHandle(index, row) {
      this.$emit("handleHandle", { index: index, row: row });
    },
    //回访
    handleRecall(index, row) {
      this.$emit("handleRecall", { index: index, row: row });
    },
    //同意退款
    handleRefund(index, row) {
      this.$emit("handleRefund", { index: index, row: row });
    },
    //上下线记录
    handleUpDownRecord(index, row) {
      this.$emit("handleUpDownRecord", { index: index, row: row });
    },
    handleUpDown(index, row) {
      this.$emit("handleUpDown", { index: index, row: row });
    },
    // 播放
    handlePlay(index, row) {
      this.$emit("handlePlay", { index: index, row: row });
    },
    // 激活
    handleActivate(index, row) {
      this.$emit("handleActivate", { index: index, row: row });
    },
    //审批
    handleMerchandis(index, row) {
      this.$emit("handleMerchandis", { index: index, row: row });
    },
    // 会员福利
    handleVipWelfare(index, row) {
      this.$emit("handleVipWelfare", { index: index, row: row });
    },
    // 集团化萤石摄像头视频播放
    handleCamearaPlay(index, row) {
      this.$emit("handleCamearaPlay", { index: index, row: row });
    },
    // 集团化萤石摄像头添加展示
    handleProducts(index, row) {
      this.$emit("handleProducts", { index: index, row: row });
    },
    // 集团化萤石摄像头取消展示
    handleOffProducts(index, row) {
      this.$emit("handleOffProducts", { index: index, row: row });
    },
    //表格单元格的点击事件
    cellClick(row, column, cell, event) {
      this.$emit("cellClick", {
        row: row,
        column: column,
        cell: cell,
        event: event,
      });
    },
    deletePageSelections() {
      this.pageSelections = {};
      this.$emit("selectionChange", { pageSelections: this.pageSelections });
    },
  },
  watch: {
    data(newVal) {
      if (this.pageSelections[newVal.pageNum]) {
        this.$nextTick(() => {
          let selections = this.pageSelections[newVal.pageNum];
          for (let i = 0; i < this.data.list.length; i++) {
            for (let j = 0; j < selections.length; j++) {
              if (this.data.list[i].id === selections[j].id) {
                this.$refs.KTtable.toggleRowSelection(this.data.list[i], true);
              }
            }
          }
        });
      }
    },
  },
  mounted() {
    this.refreshPageRequest(1);
  },
  created() {
    bus.$on("setPageSize", (pageNum) => {
      console.log(pageNum, "ddecreasedatadatadatadata");
      this.pageRequest.pageNum = pageNum;
    });
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table__fixed-right {
  height: 100% !important;
}
</style>
